;(function () {
	var STORAGE_KEY = "mx-product-compare-v1"
	var STORAGE_TTL_MS = 168 * 60 * 60 * 1000
	var APP_SELECTOR = "[data-new-product-compare-app]"
	var PRODUCT_SCRIPT_SELECTOR = "[data-product-compare-product]"
	var CARD_SELECTOR = "[data-product-compare-card]"
	var PANEL_CLASS_VISIBLE = "is-visible"
	var MODAL_CLASS_OPEN = "is-open"
	var ALERT_CLASS_VISIBLE = "is-visible"
	var CARD_CLASS_SELECTED = "is-selected"
	var CARD_CLASS_BASE = "npc-card"
	var PDP_READY_CLASS = "is-ready"
	var defaults = {
		enabled: false,
		maxProducts: 4,
		floatingLabel: "Comparador activo",
		selectedCountLabel: "productos seleccionados",
		viewComparisonLabel: "Ver comparacion",
		clearSelectionLabel: "Limpiar",
		modalHeading: "Comparacion de productos",
		modalDescription:
			"Revisa las especificaciones principales de los productos seleccionados.",
		closeLabel: "Cerrar",
		removeLabel: "Quitar",
		productRowLabel: "Producto",
		priceRowLabel: "Precio",
		linkRowLabel: "Enlace",
		brandRowLabel: "Marca",
		linkText: "Ver producto",
		emptySpecsLabel: "No disponible",
		limitReachedMessage:
			"Solo puedes comparar hasta 4 productos a la vez. Deselecciona uno para agregar otro.",
		collectionMismatchMessage:
			"Solo puedes comparar productos de la misma coleccion en este comparador.",
		productToggleLabel: "Agregar al comparador",
		productToggleSelectedLabel: "Quitar del comparador",
		addToCartIconUrl: "",
		mobileBottomOffset: 16,
		desktopBottomOffset: 24,
		rootUrl: "",
		collectionHandle: "",
		collectionTitle: "",
	}

	function normalizeRootUrl(value) {
		if (!value || value === "/") return ""
		return String(value).replace(/\/+$/, "")
	}

	function clampMaxProducts(value) {
		var parsed = parseInt(value, 10)
		if (!Number.isFinite(parsed)) return 4
		if (parsed < 2) return 2
		if (parsed > 4) return 4
		return parsed
	}

	function parseJSONText(value) {
		if (!value) return null

		try {
			return JSON.parse(value)
		} catch (error) {
			console.warn(
				"New Product Compare: no se pudo interpretar JSON.",
				error,
			)
			return null
		}
	}

	function readJSONScript(element, selector) {
		if (!element) return null
		var script = element.querySelector(selector)
		if (!script) return null
		return parseJSONText(script.textContent)
	}

	function createEmptyStore() {
		return { collections: {} }
	}

	function cloneStore(store) {
		return store && typeof store === "object" ? store : createEmptyStore()
	}

	function storageAvailable() {
		try {
			var testKey = STORAGE_KEY + ":test"
			window.localStorage.setItem(testKey, "1")
			window.localStorage.removeItem(testKey)
			return true
		} catch (error) {
			console.warn(
				"New Product Compare: localStorage no disponible.",
				error,
			)
			return false
		}
	}

	function cleanupStore(store) {
		var safeStore = cloneStore(store)
		var collections = safeStore.collections || {}
		var hasChanges = false
		var now = Date.now()

		Object.keys(collections).forEach(function (handle) {
			var entry = collections[handle]
			if (!entry || !entry.createdAt) {
				delete collections[handle]
				hasChanges = true
				return
			}

			var createdAt = new Date(entry.createdAt).getTime()
			if (
				!Number.isFinite(createdAt) ||
				now - createdAt >= STORAGE_TTL_MS
			) {
				delete collections[handle]
				hasChanges = true
			}
		})

		safeStore.collections = collections
		return {
			store: safeStore,
			hasChanges: hasChanges,
		}
	}

	function loadStore() {
		if (!storageAvailable()) return createEmptyStore()

		var raw = window.localStorage.getItem(STORAGE_KEY)
		var parsed = raw ? parseJSONText(raw) : createEmptyStore()
		var cleaned = cleanupStore(parsed)
		if (cleaned.hasChanges) {
			saveStore(cleaned.store)
		}
		return cleaned.store
	}

	function saveStore(store) {
		if (!storageAvailable()) return
		try {
			window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store))
		} catch (error) {
			console.warn(
				"New Product Compare: no se pudo guardar el estado.",
				error,
			)
		}
	}

	function getCollectionEntry(store, handle) {
		if (!store || !store.collections || !handle) return null
		return store.collections[handle] || null
	}

	function ensureCollectionEntry(store, config) {
		var safeStore = cloneStore(store)
		if (!safeStore.collections) safeStore.collections = {}

		var handle = config.collectionHandle
		if (!handle) return safeStore

		if (!safeStore.collections[handle]) {
			safeStore.collections[handle] = {
				createdAt: new Date().toISOString(),
				updatedAt: new Date().toISOString(),
				config: {},
				products: {},
			}
		}

		var entry = safeStore.collections[handle]
		entry.updatedAt = new Date().toISOString()
		entry.config = Object.assign({}, entry.config || {}, config)

		return safeStore
	}

	function buildConfig(root, rawConfig) {
		var merged = Object.assign({}, defaults, rawConfig || {})
		if (!merged.rootUrl) {
			merged.rootUrl = root
				? root.getAttribute("data-routes-root-url") || ""
				: ""
		}
		if (!merged.collectionHandle) {
			merged.collectionHandle =
				(root &&
					(root.getAttribute("data-collection-handle") ||
						root.getAttribute(
							"data-contextual-collection-handle",
						))) ||
				""
		}
		if (!merged.collectionTitle) {
			merged.collectionTitle =
				(root && root.getAttribute("data-collection-title")) || ""
		}
		if (!merged.addToCartIconUrl) {
			merged.addToCartIconUrl =
				(root && root.getAttribute("data-add-to-cart-icon-url")) || ""
		}
		merged.rootUrl = normalizeRootUrl(merged.rootUrl)
		merged.maxProducts = clampMaxProducts(merged.maxProducts)
		return merged
	}

	function getSelectedProducts(entry) {
		if (!entry || !entry.products) return []
		return Object.keys(entry.products).map(function (handle) {
			return entry.products[handle]
		})
	}

	function buildContextualProductUrl(product, config) {
		if (!product) return "#"
		var rootUrl = normalizeRootUrl(config.rootUrl)
		var collectionHandle =
			product.collectionHandle || config.collectionHandle
		if (product.handle && collectionHandle) {
			return (
				rootUrl +
				"/collections/" +
				window.encodeURIComponent(collectionHandle) +
				"/products/" +
				window.encodeURIComponent(product.handle)
			)
		}
		return product.url || "#"
	}

	function buildSpecRows(products) {
		var orderedKeys = []
		var rowsByKey = {}

		products.forEach(function (product) {
			var specs = Array.isArray(product.specs) ? product.specs : []
			specs.forEach(function (spec) {
				if (!spec || !spec.key) return
				if (!rowsByKey[spec.key]) {
					rowsByKey[spec.key] = {
						key: spec.key,
						label: spec.label || spec.key,
						values: {},
					}
					orderedKeys.push(spec.key)
				}
				rowsByKey[spec.key].values[product.handle] = spec.value || ""
			})
		})

		return orderedKeys.map(function (key) {
			return rowsByKey[key]
		})
	}

	function getAddToCartLabel(product) {
		if (!product) return "Agregar al carrito"
		if (!product.variantId) {
			return window.Shopify &&
				Shopify.translation &&
				Shopify.translation.unavailable
				? Shopify.translation.unavailable
				: "No disponible"
		}
		if (product.available === false) {
			return window.Shopify &&
				Shopify.translation &&
				Shopify.translation.soldOut
				? Shopify.translation.soldOut
				: "Agotado"
		}
		return window.Shopify &&
			Shopify.translation &&
			Shopify.translation.addToCart
			? Shopify.translation.addToCart
			: "Agregar al carrito"
	}

	function addProductToCart(form) {
		if (!form) return

		if (
			window.jQuery &&
			window.Shopify &&
			Shopify.theme &&
			Shopify.theme.jsAjaxCart &&
			typeof Shopify.theme.jsAjaxCart.addToCart === "function"
		) {
			Shopify.theme.jsAjaxCart.addToCart(window.jQuery(form))
			return
		}

		var formData = new window.FormData(form)
		fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			body: formData,
			credentials: "same-origin",
		})
			.then(function (response) {
				if (!response.ok)
					throw new Error(
						"No se pudo agregar el producto al carrito.",
					)
				return response.json()
			})
			.then(function () {
				if (
					window.Shopify &&
					Shopify.theme &&
					Shopify.theme.jsAjaxCart
				) {
					if (
						typeof Shopify.theme.jsAjaxCart.showDrawer ===
						"function"
					) {
						Shopify.theme.jsAjaxCart.showDrawer()
					}
					if (
						typeof Shopify.theme.jsAjaxCart.updateView ===
						"function"
					) {
						Shopify.theme.jsAjaxCart.updateView()
					}
				}
			})
			.catch(function (error) {
				console.warn(
					"New Product Compare: fallo add to cart del modal.",
					error,
				)
			})
	}

	function createButtonLabel(config, isSelected) {
		return isSelected
			? config.productToggleSelectedLabel
			: config.productToggleLabel
	}

	function createToggleButton(config, isSelected, className) {
		var button = document.createElement("button")
		button.type = "button"
		button.className = className
		button.setAttribute("aria-pressed", isSelected ? "true" : "false")
		button.setAttribute("data-product-compare-toggle", "")

		var icon = document.createElement("span")
		icon.className = "npc-toggle__icon"
		icon.setAttribute("aria-hidden", "true")

		var text = document.createElement("span")
		text.className = "npc-toggle__text"
		text.textContent = createButtonLabel(config, isSelected)
		text.setAttribute("data-product-compare-toggle-text", "")

		button.appendChild(icon)
		button.appendChild(text)
		button.setAttribute("aria-label", text.textContent)

		return button
	}

	function createAppShell(root, config) {
		var shell = document.createElement("div")
		shell.className = "npc-app-shell"
		shell.innerHTML =
			'<div class="npc-alert" aria-live="polite" aria-atomic="true" data-compare-alert></div>' +
			'<div class="npc-panel" data-compare-panel>' +
			'<div class="npc-panel__inner">' +
			'<div class="npc-panel__summary">' +
			'<span class="npc-panel__label" data-compare-floating-label></span>' +
			'<span class="npc-panel__count"><span data-compare-count>0</span> <span data-compare-count-label></span></span>' +
			"</div>" +
			'<div class="npc-panel__actions">' +
			'<button type="button" class="npc-panel__ghost" data-compare-clear></button>' +
			'<button type="button" class="npc-panel__button" data-compare-open></button>' +
			"</div>" +
			"</div>" +
			"</div>" +
			'<div class="npc-modal" data-compare-modal>' +
			'<div class="npc-modal__backdrop" data-compare-close-modal></div>' +
			'<div class="npc-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="npc-modal-title" tabindex="-1">' +
			'<div class="npc-modal__header">' +
			"<div>" +
			'<h2 id="npc-modal-title" class="npc-modal__title"></h2>' +
			'<p class="npc-modal__description" data-compare-modal-description></p>' +
			"</div>" +
			'<button type="button" class="npc-modal__close" data-compare-close-modal></button>' +
			"</div>" +
			'<div class="npc-modal__body" data-compare-modal-body></div>' +
			"</div>" +
			"</div>"

		root.appendChild(shell)
		root.style.setProperty(
			"--npc-mobile-offset",
			String(config.mobileBottomOffset || 16) + "px",
		)
		root.style.setProperty(
			"--npc-desktop-offset",
			String(config.desktopBottomOffset || 24) + "px",
		)

		return {
			shell: shell,
			alert: shell.querySelector("[data-compare-alert]"),
			panel: shell.querySelector("[data-compare-panel]"),
			count: shell.querySelector("[data-compare-count]"),
			countLabel: shell.querySelector("[data-compare-count-label]"),
			floatingLabel: shell.querySelector("[data-compare-floating-label]"),
			clearButton: shell.querySelector("[data-compare-clear]"),
			openButton: shell.querySelector("[data-compare-open]"),
			modal: shell.querySelector("[data-compare-modal]"),
			modalDialog: shell.querySelector(".npc-modal__dialog"),
			modalTitle: shell.querySelector(".npc-modal__title"),
			modalDescription: shell.querySelector(
				"[data-compare-modal-description]",
			),
			modalBody: shell.querySelector("[data-compare-modal-body]"),
			closeButtons: shell.querySelectorAll("[data-compare-close-modal]"),
		}
	}

	function updateToggleButton(button, config, isSelected) {
		if (!button) return
		button.setAttribute("aria-pressed", isSelected ? "true" : "false")
		var text = button.querySelector("[data-product-compare-toggle-text]")
		var label = createButtonLabel(config, isSelected)
		if (text) text.textContent = label
		button.setAttribute("aria-label", label)
	}

	function withStore(callback) {
		var store = loadStore()
		var result = callback(store) || {}
		if (result.store) {
			saveStore(result.store)
		}
		return result
	}

	function createController(root, config) {
		var ui = createAppShell(root, config)
		var mode = root.getAttribute("data-compare-mode") || "collection"
		var collectionHandle = config.collectionHandle
		var collectionGrid = null
		var alertTimer = null
		var focusBeforeModal = null
		var mutationObserver = null
		var pdpPlacementObserver = null
		var pdpContainer = mode === "product" ? root : null
		var pdpToggleHost = pdpContainer
			? root.querySelector("[data-product-compare-pdp-toggle]")
			: null
		var pdpProductData = pdpContainer
			? readJSONScript(pdpContainer, PRODUCT_SCRIPT_SELECTOR)
			: null
		var pdpToggleButton = null

		function getEntry() {
			return getCollectionEntry(loadStore(), collectionHandle)
		}

		function persistConfig() {
			withStore(function (store) {
				return {
					store: ensureCollectionEntry(store, config),
				}
			})
		}

		function showAlert(message) {
			if (!ui.alert || !message) return
			ui.alert.innerHTML =
				'<span class="npc-alert__title">Comparador</span>' +
				'<span class="npc-alert__message"></span>'
			var messageNode = ui.alert.querySelector(".npc-alert__message")
			if (messageNode) messageNode.textContent = message
			ui.alert.classList.add(ALERT_CLASS_VISIBLE)

			window.clearTimeout(alertTimer)
			alertTimer = window.setTimeout(function () {
				ui.alert.classList.remove(ALERT_CLASS_VISIBLE)
			}, 3200)
		}

		function upsertProduct(productData) {
			if (!productData || !productData.handle) {
				return { type: "error", message: config.emptySpecsLabel }
			}

			if (
				productData.collectionHandle &&
				productData.collectionHandle !== collectionHandle
			) {
				return {
					type: "error",
					message: config.collectionMismatchMessage,
				}
			}

			return withStore(function (store) {
				var nextStore = ensureCollectionEntry(store, config)
				var entry = getCollectionEntry(nextStore, collectionHandle)
				var products = entry.products || {}
				var alreadySelected = Boolean(products[productData.handle])

				if (alreadySelected) {
					delete products[productData.handle]
					entry.products = products
					entry.updatedAt = new Date().toISOString()
					return {
						type: "removed",
						store: nextStore,
					}
				}

				if (Object.keys(products).length >= config.maxProducts) {
					return {
						type: "error",
						message: config.limitReachedMessage,
					}
				}

				products[productData.handle] = Object.assign({}, productData, {
					collectionHandle: collectionHandle,
					collectionTitle: config.collectionTitle,
				})
				entry.products = products
				entry.updatedAt = new Date().toISOString()

				return {
					type: "added",
					store: nextStore,
				}
			})
		}

		function clearSelection() {
			withStore(function (store) {
				var nextStore = ensureCollectionEntry(store, config)
				var entry = getCollectionEntry(nextStore, collectionHandle)
				if (entry) {
					entry.products = {}
					entry.updatedAt = new Date().toISOString()
				}
				return { store: nextStore }
			})
			render()
		}

		function removeProduct(handle) {
			withStore(function (store) {
				var nextStore = ensureCollectionEntry(store, config)
				var entry = getCollectionEntry(nextStore, collectionHandle)
				if (entry && entry.products && entry.products[handle]) {
					delete entry.products[handle]
					entry.updatedAt = new Date().toISOString()
				}
				return { store: nextStore }
			})
			render()
		}

		function getSelectedHandles() {
			var entry = getEntry()
			var products = entry && entry.products ? entry.products : {}
			return Object.keys(products)
		}

		function getSelectedProductsList() {
			return getSelectedProducts(getEntry())
		}

		function parseCardProduct(card) {
			return readJSONScript(card, PRODUCT_SCRIPT_SELECTOR)
		}

		function syncCardSelectionState() {
			if (!collectionGrid) return
			var selectedHandles = getSelectedHandles()
			var cards = collectionGrid.querySelectorAll(CARD_SELECTOR)
			Array.prototype.forEach.call(cards, function (card) {
				var handle = card.getAttribute(
					"data-product-compare-product-handle",
				)
				var isSelected = selectedHandles.indexOf(handle) >= 0
				card.classList.toggle(CARD_CLASS_SELECTED, isSelected)
				var button = card.querySelector("[data-product-compare-toggle]")
				updateToggleButton(button, config, isSelected)
			})
		}

		function ensureCardButtons() {
			if (!collectionGrid) return
			var cards = collectionGrid.querySelectorAll(CARD_SELECTOR)
			Array.prototype.forEach.call(cards, function (card) {
				card.classList.add(CARD_CLASS_BASE)

				if (card.querySelector("[data-product-compare-toggle]")) return

				var handle = card.getAttribute(
					"data-product-compare-product-handle",
				)
				var isSelected = getSelectedHandles().indexOf(handle) >= 0
				var button = createToggleButton(
					config,
					isSelected,
					"npc-card__toggle",
				)
				card.insertBefore(button, card.firstChild)
			})

			syncCardSelectionState()
		}

		function ensurePdpToggle() {
			if (!pdpContainer || !pdpToggleHost || !pdpProductData) return
			pdpContainer.classList.add("npc-pdp")
			if (!config.enabled || !collectionHandle) return

			if (!pdpToggleButton) {
				pdpToggleButton = createToggleButton(
					config,
					false,
					"npc-pdp__toggle",
				)
				pdpToggleHost.appendChild(pdpToggleButton)
			}

			var isSelected =
				getSelectedHandles().indexOf(pdpProductData.handle) >= 0
			updateToggleButton(pdpToggleButton, config, isSelected)
			pdpToggleHost.classList.toggle("is-selected", isSelected)
			pdpContainer.classList.add(PDP_READY_CLASS)
		}

		function syncPdpPlacement() {
			if (!pdpContainer) return

			var formContainer =
				pdpContainer.closest(".product-form-container") ||
				pdpContainer.parentElement
			if (!formContainer) return

			var availabilityContainer = formContainer.querySelector(
				".store-availability-container",
			)
			if (
				!availabilityContainer ||
				availabilityContainer === pdpContainer
			)
				return

			if (availabilityContainer.previousElementSibling !== pdpContainer) {
				availabilityContainer.parentNode.insertBefore(
					pdpContainer,
					availabilityContainer,
				)
			}
		}

		function focusableElements(container) {
			if (!container) return []
			return Array.prototype.slice
				.call(
					container.querySelectorAll(
						'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
					),
				)
				.filter(function (element) {
					return element.offsetParent !== null
				})
		}

		function handleModalKeydown(event) {
			if (event.key === "Escape") {
				event.preventDefault()
				closeModal()
				return
			}

			if (event.key !== "Tab") return
			var focusables = focusableElements(ui.modalDialog)
			if (!focusables.length) return
			var first = focusables[0]
			var last = focusables[focusables.length - 1]

			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault()
				last.focus()
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault()
				first.focus()
			}
		}

		function openModal() {
			if (getSelectedProductsList().length === 0) return
			focusBeforeModal = document.activeElement
			ui.modal.classList.add(MODAL_CLASS_OPEN)
			document.body.style.overflow = "hidden"
			ui.modalDialog.addEventListener("keydown", handleModalKeydown)
			window.setTimeout(function () {
				ui.modalDialog.focus()
			}, 0)
		}

		function closeModal() {
			ui.modal.classList.remove(MODAL_CLASS_OPEN)
			document.body.style.overflow = ""
			ui.modalDialog.removeEventListener("keydown", handleModalKeydown)
			if (
				focusBeforeModal &&
				typeof focusBeforeModal.focus === "function"
			) {
				focusBeforeModal.focus()
			}
		}

		function renderModal(products) {
			ui.modalTitle.textContent = config.modalHeading
			ui.modalDescription.textContent = config.modalDescription
			Array.prototype.forEach.call(ui.closeButtons, function (button) {
				button.textContent = config.closeLabel
				button.setAttribute("aria-label", config.closeLabel)
			})

			if (!products.length) {
				ui.modalBody.innerHTML =
					'<p class="npc-modal__empty">' +
					config.emptySpecsLabel +
					"</p>"
				return
			}

			var rows = buildSpecRows(products)
			var parts = []
			parts.push('<table class="npc-table">')
			parts.push("<tbody>")

			parts.push("<tr>")
			parts.push(
				'<th scope="row">' +
					escapeHtml(config.productRowLabel) +
					"</th>",
			)
			products.forEach(function (product) {
				parts.push("<td>")
				parts.push('<div class="npc-product-cell">')
				if (product.image) {
					parts.push(
						'<img class="npc-product-cell__image" src="' +
							escapeAttribute(product.image) +
							'" alt="' +
							escapeAttribute(product.title || "") +
							'">',
					)
				}
				parts.push(
					'<span class="npc-product-cell__title">' +
						escapeHtml(product.title || "") +
						"</span>",
				)
				parts.push('<div class="npc-product-cell__actions">')
				parts.push(
					'<a class="npc-link-button" href="' +
						escapeAttribute(
							buildContextualProductUrl(product, config),
						) +
						'">' +
						escapeHtml(config.linkText) +
						"</a>",
				)
				parts.push(
					'<button type="button" class="npc-remove-button" data-compare-remove="' +
						escapeAttribute(product.handle) +
						'">' +
						escapeHtml(config.removeLabel) +
						"</button>",
				)
				parts.push("</div>")
				parts.push("</div>")
				parts.push("</td>")
			})
			parts.push("</tr>")

			parts.push("<tr>")
			parts.push(
				'<th scope="row">' + escapeHtml(config.priceRowLabel) + "</th>",
			)
			products.forEach(function (product) {
				var priceClass = product.compareAtPriceText
					? "npc-price npc-price--sale"
					: "npc-price"
				parts.push("<td>")
				parts.push(
					'<span class="' +
						priceClass +
						'">' +
						escapeHtml(
							product.priceText || config.emptySpecsLabel,
						) +
						"</span>",
				)
				if (product.compareAtPriceText) {
					parts.push(
						'<span class="npc-price--compare">' +
							escapeHtml(product.compareAtPriceText) +
							"</span>",
					)
				}
				parts.push("</td>")
			})
			parts.push("</tr>")

			parts.push("<tr>")
			parts.push(
				'<th scope="row">' + escapeHtml(config.linkRowLabel) + "</th>",
			)
			products.forEach(function (product) {
				var addToCartLabel = getAddToCartLabel(product)
				var isAddToCartDisabled =
					!product.variantId || product.available === false
				var addToCartIcon = config.addToCartIconUrl
					? '<img class="npc-add-to-cart-icon" src="' +
						escapeAttribute(config.addToCartIconUrl) +
						'" alt="" aria-hidden="true">'
					: ""
				parts.push("<td>")
				parts.push(
					'<form class="npc-add-to-cart-form" data-compare-add-to-cart-form>' +
						'<input type="hidden" name="id" value="' +
						escapeAttribute(product.variantId || "") +
						'">' +
						'<input type="hidden" name="quantity" value="1">' +
						'<button type="button" class="button ajax-submit action_button button--add-to-cart npc-add-to-cart-button' +
						(isAddToCartDisabled ? " disabled" : "") +
						'" data-label="' +
						escapeAttribute(addToCartLabel) +
						'" data-compare-add-to-cart="' +
						escapeAttribute(product.handle) +
						'"' +
						(isAddToCartDisabled ? ' disabled="disabled"' : "") +
						">" +
						addToCartIcon +
						'<span class="text">' +
						escapeHtml(addToCartLabel) +
						"</span></button>" +
						"</form>",
				)
				parts.push("</td>")
			})
			parts.push("</tr>")

			parts.push("<tr>")
			parts.push(
				'<th scope="row">' + escapeHtml(config.brandRowLabel) + "</th>",
			)
			products.forEach(function (product) {
				parts.push("<td>")
				parts.push(escapeHtml(product.vendor || config.emptySpecsLabel))
				parts.push("</td>")
			})
			parts.push("</tr>")

			rows.forEach(function (row) {
				parts.push("<tr>")
				parts.push('<th scope="row">' + escapeHtml(row.label) + "</th>")
				products.forEach(function (product) {
					var value =
						row.values[product.handle] || config.emptySpecsLabel
					parts.push("<td>" + escapeHtml(value) + "</td>")
				})
				parts.push("</tr>")
			})

			parts.push("</tbody>")
			parts.push("</table>")
			ui.modalBody.innerHTML = parts.join("")
		}

		function renderPanel(products) {
			ui.floatingLabel.textContent = config.floatingLabel
			ui.count.textContent = String(products.length)
			ui.countLabel.textContent = config.selectedCountLabel
			ui.clearButton.textContent = config.clearSelectionLabel
			ui.openButton.textContent = config.viewComparisonLabel
			ui.openButton.disabled = products.length === 0

			if (products.length > 0 && config.enabled) {
				ui.panel.classList.add(PANEL_CLASS_VISIBLE)
			} else {
				ui.panel.classList.remove(PANEL_CLASS_VISIBLE)
				closeModal()
			}
		}

		function render() {
			if (!config.enabled) {
				ui.panel.classList.remove(PANEL_CLASS_VISIBLE)
				closeModal()
				return
			}

			var products = getSelectedProductsList()
			renderPanel(products)
			renderModal(products)
			syncCardSelectionState()
			ensurePdpToggle()
		}

		function handleToggle(productData) {
			var result = upsertProduct(productData)
			if (result.type === "error") {
				showAlert(result.message)
				return
			}
			render()
		}

		function bindUI() {
			ui.openButton.addEventListener("click", openModal)
			ui.clearButton.addEventListener("click", clearSelection)

			Array.prototype.forEach.call(ui.closeButtons, function (button) {
				button.addEventListener("click", closeModal)
			})

			ui.modalBody.addEventListener("click", function (event) {
				var removeButton = event.target.closest("[data-compare-remove]")
				if (!removeButton) return
				event.preventDefault()
				removeProduct(removeButton.getAttribute("data-compare-remove"))
			})

			ui.modalBody.addEventListener("click", function (event) {
				var addToCartButton = event.target.closest(
					"[data-compare-add-to-cart]",
				)
				if (!addToCartButton) return
				event.preventDefault()
				if (addToCartButton.hasAttribute("disabled")) return

				var form = addToCartButton.closest(
					"[data-compare-add-to-cart-form]",
				)
				if (!form) return

				closeModal()
				addProductToCart(form)
			})

			ui.modal.addEventListener("click", function (event) {
				if (event.target.hasAttribute("data-compare-close-modal")) {
					closeModal()
				}
			})
		}

		function bindCollectionInteractions() {
			collectionGrid = document.querySelector(
				'.collection-wrapper[data-collection-handle="' +
					CSS.escape(collectionHandle) +
					'"] [data-collection-products-grid]',
			)
			if (!collectionGrid) return

			ensureCardButtons()

			collectionGrid.addEventListener("click", function (event) {
				var button = event.target.closest(
					"[data-product-compare-toggle]",
				)
				if (!button) return
				event.preventDefault()
				event.stopPropagation()

				var card = button.closest(CARD_SELECTOR)
				if (!card) return
				var productData = parseCardProduct(card)
				handleToggle(productData)
			})

			mutationObserver = new MutationObserver(function () {
				ensureCardButtons()
			})
			mutationObserver.observe(collectionGrid, { childList: true })
		}

		function bindProductInteractions() {
			if (!pdpContainer || !pdpToggleHost) return
			ensurePdpToggle()
			syncPdpPlacement()

			if (!pdpPlacementObserver) {
				pdpPlacementObserver = new MutationObserver(function () {
					syncPdpPlacement()
				})
				pdpPlacementObserver.observe(document.body, {
					childList: true,
					subtree: true,
				})
			}

			root.addEventListener("click", function (event) {
				var button = event.target.closest(
					"[data-product-compare-toggle]",
				)
				if (!button || !pdpContainer.contains(button)) return
				event.preventDefault()
				handleToggle(pdpProductData)
			})
		}

		function onStorageSync(event) {
			if (event.key && event.key !== STORAGE_KEY) return
			render()
		}

		function init() {
			bindUI()

			if (mode === "collection") {
				persistConfig()
				if (!config.enabled) return
				bindCollectionInteractions()
			} else if (mode === "product") {
				var persistedEntry = getEntry()
				if (
					!persistedEntry ||
					!persistedEntry.config ||
					persistedEntry.config.enabled !== true
				)
					return
				config = buildConfig(root, persistedEntry.config)
				root.style.setProperty(
					"--npc-mobile-offset",
					String(config.mobileBottomOffset || 16) + "px",
				)
				root.style.setProperty(
					"--npc-desktop-offset",
					String(config.desktopBottomOffset || 24) + "px",
				)
				bindProductInteractions()
			}

			window.addEventListener("storage", onStorageSync)
			render()
		}

		init()
	}

	// CSS.escape fallback for older environments.
	if (!window.CSS || typeof window.CSS.escape !== "function") {
		window.CSS = window.CSS || {}
		window.CSS.escape = function (value) {
			return String(value).replace(/["\\#.:?+<>=~*^$|[\]()]/g, "\\$&")
		}
	}

	function escapeHtml(value) {
		return String(value == null ? "" : value)
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#39;")
	}

	function escapeAttribute(value) {
		return escapeHtml(value)
	}

	function initAllCompareApps() {
		var roots = document.querySelectorAll(APP_SELECTOR)
		Array.prototype.forEach.call(roots, function (root) {
			if (root.getAttribute("data-product-compare-init") === "true")
				return
			root.setAttribute("data-product-compare-init", "true")

			var mode = root.getAttribute("data-compare-mode") || "collection"
			var config =
				mode === "collection"
					? readJSONScript(root, "[data-product-compare-config]")
					: {}
			createController(root, buildConfig(root, config))
		})
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initAllCompareApps)
	} else {
		initAllCompareApps()
	}
})()
